/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Column_Organization2Inputs */

const en_settings_reportingapikeys_column_organization2 = /** @type {(inputs: Settings_Reportingapikeys_Column_Organization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {Settings_Reportingapikeys_Column_Organization2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_column_organization2 = /** @type {((inputs?: Settings_Reportingapikeys_Column_Organization2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Column_Organization2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_column_organization2(inputs)
});
export { settings_reportingapikeys_column_organization2 as "settings_reportingApiKeys_column_organization" }